import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import theme from './theme';
import Layout from './components/layout/Layout';

// Pages
import HomePage from './pages/HomePage';
import QuestionPage from './pages/QuestionPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ApiUnavailablePage from './pages/ApiUnavailablePage';
import TrackRoadmapPage from './pages/TrackRoadmapPage';
import SearchPage from './pages/SearchPage';
import MyLearningPage from './pages/MyLearningPage';
import CohortPilotPage from './pages/CohortPilotPage';
import AdminPage from './pages/AdminPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import AccountSettingsPage from './pages/AccountSettingsPage';
import { AuthProvider } from './auth/AuthContext';
import ProtectedLearningRoute from './components/auth/ProtectedLearningRoute';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={{
        html: { overflowX: 'clip' },
        body: { overflowX: 'hidden', width: '100%' },
        '#root': { overflowX: 'hidden', width: '100%' },
      }} />
      <AuthProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/questions/*" element={<ProtectedLearningRoute><QuestionPage /></ProtectedLearningRoute>} />
            <Route path="/roadmaps/:trackSlug" element={<ProtectedLearningRoute><TrackRoadmapPage /></ProtectedLearningRoute>} />
            <Route path="/search" element={<ProtectedLearningRoute><SearchPage /></ProtectedLearningRoute>} />
            <Route path="/my-learning" element={<ProtectedLearningRoute><MyLearningPage /></ProtectedLearningRoute>} />
            <Route path="/cohort" element={<ProtectedLearningRoute><CohortPilotPage /></ProtectedLearningRoute>} />
            <Route path="/admin" element={<ProtectedLearningRoute><AdminPage /></ProtectedLearningRoute>} />
            <Route path="/settings" element={<ProtectedLearningRoute><AccountSettingsPage /></ProtectedLearningRoute>} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/api-unavailable" element={<ApiUnavailablePage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </Layout>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
